const data = {
    title: '6. Kennisleemtes en vervolgonderzoek',
    content: <>
        <p>Dit hoofdstuk beschrijft de leemten in kennis in dit MER en de monitoring en evaluatie van het doelbereik en de milieueffecten van de herziening van de module Energietransitie.</p>
        
    </>,
    prev: '/energietransitie-05-05-2022/5/4',
    next: '/energietransitie-05-05-2022/6/1',

}

export default data